import React from "react";
import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { getDefaultStyles } from "../PdfStyles";
import { FirstCell } from "./FirstCell";
import { Cell } from "./Cell";
import { ComponentProps } from "../PdfPage";
import {
  MEMBERSHIP_OPTIONS_LABEL_MAPPING,
  MembershipOptions,
} from "../../../../data/dataBusinessRisk";

function getSpecificStyles(show: boolean) {
  return StyleSheet.create({
    info: {
      margin: "20px 0 10px 0",
    },
  });
}

function getLabels(t: any) {
  return {
    header: t("Subscription and/or Membership"),
    info: t("Average time until activation"),
    partOfSales: t("Part of sales"),
  };
}

export const Subscriptions: React.FunctionComponent<ComponentProps> = ({
  show = true,
}) => {
  const { t } = useTranslation();
  const labels = getLabels(t);
  const styles = {
    ...getDefaultStyles(show),
    ...getSpecificStyles(show),
  };

  return (
    <>
      <View style={styles.sectionHeader}>
        <Text>{labels.header}</Text>
      </View>

      <View>
        <FirstCell label={labels.partOfSales} show={show}>
          44 %
        </FirstCell>
      </View>

      <Text style={styles.info}>{labels.info}</Text>

      <View style={styles.split}>
        <View style={styles.quarterColumn}>
          <FirstCell
            label={t(
              MEMBERSHIP_OPTIONS_LABEL_MAPPING[MembershipOptions.ZERO__ONE]
            )}
            show={show}
          >
            10 %
          </FirstCell>
        </View>
        <View style={styles.quarterColumn}>
          <Cell
            label={t(MEMBERSHIP_OPTIONS_LABEL_MAPPING[MembershipOptions.THREE])}
            show={show}
          >
            10 %
          </Cell>
        </View>
        <View style={styles.quarterColumn}>
          <Cell
            label={t(MEMBERSHIP_OPTIONS_LABEL_MAPPING[MembershipOptions.YEAR])}
            show={show}
          >
            10 %
          </Cell>
        </View>
        <View style={styles.quarterColumn}>
          <Cell
            label={t(MEMBERSHIP_OPTIONS_LABEL_MAPPING[MembershipOptions.OTHER])}
            show={show}
          >
            10 %
          </Cell>
        </View>
      </View>
    </>
  );
};
